module.exports = __webpack_public_path__ + "img/attach-file-rounded.f0c5e240.svg";